export default {"src":"/_next/static/media/effect-stripes.142a5c0a.svg","height":565,"width":362,"blurWidth":0,"blurHeight":0};